
import { WPS_Input } from './WPS_Input';
import { Tooltip_detail as Tooltip } from '../../utility/common/helpers/Tooltip';
import Error from '../../../icons/ErrorIcon.svg';
import { isAllowCustomSpecialCharacters } from '../../../functions/validations';

const RadioButton = ({ value, label, radioName, radioValue, handleRadioChange }) => (
  <td>
    <div>
      <input
        type="radio"
        name={radioName}
        value={value}
        checked={radioValue === value}
        onChange={() => handleRadioChange(value)}
      />
      <span className={radioValue === value ? "fontWeight ms-2" : "ms-2"}>
        {label}
      </span>
    </div>
  </td>
);
export const WPSFillerMetalRow = ({
  title,
  prefix,
  radioName,
  headerObj,
  setheaderObj,
  error,
  setError,
  handleChange,
  action,

  
  message,
  detailObj,
  setdetailObj
}) => {
  const hasError = error.length > 1;
  const radioValue = headerObj[radioName];

     const getErrormessage = (errobj) => {
      let msg = ""
   
      //console.log("consuma error",errobj)
      //msg = errobj.msg
      let allmsg = "";
      errobj.map((i) => {
        if (i.id !== "" && i.id !== "all") msg = i.msg + ", ";
        if (i.id === "all") allmsg = i.msg;
      });
      msg = msg + allmsg; 
      return msg;
    };

  const clearFields = () => {
    const fields = ['SFA', 'Classification', 'FNo', 'ANo', 'ChemicalAnalysis_TradeName'];
    const updates = {};
    fields.forEach(field => {
      updates[`${prefix}_${field}`] = '';
    });
    setheaderObj(prev => ({ ...prev, ...updates }));
  };

  const clearFieldsWithDash = () => {
    const fields = ['SFA', 'Classification', 'FNo', 'ANo', 'ChemicalAnalysis_TradeName'];
    const updates = {};
    fields.forEach(field => {
      updates[`${prefix}_${field}`] = '-';
    });
    setheaderObj(prev => ({ ...prev, ...updates }));
  };

  const handleRadioChange = (value) => {
    handleChange({ target: { name: radioName, value } });
    
    if (value === 'Required') {
      clearFields();
       setError(result => {
        const resultArray = Array.isArray(result) ? result : [];
        return [...resultArray.filter(i => i.id !== 'all'), {
          id: 'all',
          msg: 'All fields are Mandatory',
          className: 'border radioInput error'
        }];
      }); 
    } else if (value === 'None') {
      clearFieldsWithDash();
      if (prefix === 'WPSH_Flux' && detailObj && setdetailObj) {
        detailObj.forEach(item => item.WPSD_Flux_Details_WI_CHECK = false);
        setdetailObj([...detailObj]);
      }
    }
    
    setError(result => {
      const resultArray = Array.isArray(result) ? result : [];
      return resultArray.filter(i => i.id !== 'all');
    }); 
  };

  return (
    <tr className={hasError ? "border radioInput error" : "border radioInput"}>
      <th className={hasError ? "error-head" : ""}>
        <div className={title === "Consumable Insert" ? "Groove_green" : ""} 
             style={{ textAlign: "left", position: "relative", left: "1px" }}>
          {title}
          {hasError && (
            <Tooltip content={getErrormessage(error)}>
              {"   "}<img src={Error} alt="Error" className="ms-1" />
            </Tooltip>
          )}
        </div>
      </th>
      
      <td className="WpsInput">
        <WPS_Input
          valuefield={headerObj[`${prefix}_SFA`]}
          handleChange={handleChange}
          status={error}
          setError={setError}
          maxLength={3}
          id={`${prefix}_SFA`}
          required={radioValue}
          action={action}
          setErrorObj={setError}
        />
      </td>
      
      <td className="WpsInput">
        <WPS_Input
          valuefield={headerObj[`${prefix}_Classification`]}
          handleChange={handleChange}
          maxLength={12}
          status={error}
          setError={setError}
          id={`${prefix}_Classification`}
          required={radioValue}
          action={action}
          setErrorObj={setError}
          allowlistfunction={isAllowCustomSpecialCharacters}
          allowcharacters="-"
          customMessage="Special Characters # &  % +  $ ' < > = ; not allowed"
        />
      </td>
      
      <td className="WpsInput">
        <WPS_Input
          valuefield={headerObj[`${prefix}_FNo`]}
          handleChange={handleChange}
          maxLength={3}
          status={error}
          setError={setError}
          id={`${prefix}_FNo`}
          required={radioValue}
          action={action}
          setErrorObj={setError}
        />
      </td>
      
      <td className="WpsInput">
        <WPS_Input
          valuefield={headerObj[`${prefix}_ANo`]}
          handleChange={handleChange}
          maxLength={3}
          status={error}
          setError={setError}
          id={`${prefix}_ANo`}
          required={radioValue}
          action={action}
          setErrorObj={setError}
        />
      </td>
      
      <td className="WpsInput">
        <WPS_Input
          valuefield={headerObj[`${prefix}_ChemicalAnalysis_TradeName`]}
          handleChange={handleChange}
          maxLength={headerObj.wld_WPSType === "Groove" ? 30 : 28}
          status={error}
          setError={setError}
          id={`${prefix}_ChemicalAnalysis_TradeName`}
          required={radioValue}
          action={action}
          setErrorObj={setError}
          allowlistfunction={isAllowCustomSpecialCharacters}
          allowcharacters="&-"
          customMessage="Special Characters #  % +  $ ' < > = ; not allowed"
        />
      </td>
      
      <RadioButton value="Required" label="Required" radioName={radioName} radioValue={radioValue} handleRadioChange={handleRadioChange} />
      <RadioButton value="Optional" label="Optional" radioName={radioName} radioValue={radioValue} handleRadioChange={handleRadioChange} />
      <RadioButton value="None" label="None" radioName={radioName} radioValue={radioValue} handleRadioChange={handleRadioChange} />
    </tr>
  );
};

export default WPSFillerMetalRow;